/**
 * @generated SignedSource<<91ed267a4d34ba274ee741fb09198ac4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type QUANTITY_LOCKED_REASON = "FIXED_PRICE" | "FIXED_PRICE_PERIOD" | "FIXED_PRICE_DELIVERABLE" | "%future added value";
export type CreateInvoiceInput = {
  clientId?: string | null;
  clientContactId?: string | null;
  projectId?: string | null;
  name: string;
  currency?: string | null;
  invoiceReference?: string | null;
  invoiceType?: string | null;
  status?: string | null;
  dueDay?: number | null;
  dueMonth?: number | null;
  dueYear?: number | null;
  createdDay?: number | null;
  createdMonth?: number | null;
  createdYear?: number | null;
  notes?: string | null;
  entries: ReadonlyArray<InvoiceEntryInput | null>;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type InvoiceEntryInput = {
  id?: string | null;
  name?: string | null;
  projectId?: string | null;
  quantity?: number | null;
  quantityText?: string | null;
  unitPrice?: number | null;
  discount?: number | null;
  tax?: number | null;
  description?: string | null;
  timeRegIds?: ReadonlyArray<string | null> | null;
  expenseItemIds?: ReadonlyArray<string | null> | null;
  periodIds?: ReadonlyArray<string | null> | null;
  deliverableIds?: ReadonlyArray<string | null> | null;
  externalRefs?: ReadonlyArray<ExternalRef | null> | null;
  quantityLockedReason?: QUANTITY_LOCKED_REASON | null;
};
export type ExternalRef = {
  key?: string | null;
  value?: string | null;
};
export type createInvoiceMutation$variables = {
  input: CreateInvoiceInput;
};
export type createInvoiceMutation$data = {
  readonly createInvoice: {
    readonly invoice: {
      readonly node: {
        readonly id: string;
        readonly invoiceReference: string | null;
        readonly companyInvoiceId: number | null;
        readonly name: string | null;
        readonly currency: string | null;
        readonly invoiceType: string | null;
        readonly status: string | null;
        readonly dueDay: number | null;
        readonly dueMonth: number | null;
        readonly dueYear: number | null;
        readonly createdDay: number | null;
        readonly createdMonth: number | null;
        readonly createdYear: number | null;
        readonly notes: string | null;
        readonly quickbooksId: number | null;
        readonly xeroId: string | null;
        readonly economicId: number | null;
        readonly clientContact: {
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
        } | null;
        readonly project: {
          readonly retainerPeriods: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly invoiced: boolean | null;
              } | null;
            } | null> | null;
          } | null;
        } | null;
        readonly entries: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly name: string | null;
              readonly quantity: number | null;
              readonly unitPrice: number | null;
              readonly discount: number | null;
              readonly tax: number | null;
              readonly description: string | null;
            } | null;
          } | null> | null;
        } | null;
        readonly payments: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly notes: string | null;
              readonly amount: number | null;
              readonly day: number | null;
              readonly month: number | null;
              readonly year: number | null;
              readonly createdAt: string | null;
              readonly createdBy: {
                readonly fullName: string | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type createInvoiceMutation = {
  variables: createInvoiceMutation$variables;
  response: createInvoiceMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceReference",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyInvoiceId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceType",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueDay",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueMonth",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueYear",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDay",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdMonth",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdYear",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quickbooksId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "xeroId",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "economicId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "ClientContact",
  "kind": "LinkedField",
  "name": "clientContact",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiced",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "InvoiceEntryTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "InvoiceEntryType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quantity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unitPrice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tax",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          (v21/*: any*/)
        ],
        "storageKey": null
      },
      (v22/*: any*/)
    ],
    "storageKey": null
  },
  (v23/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v31 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000000
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createInvoiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateInvoicePayload",
        "kind": "LinkedField",
        "name": "createInvoice",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceTypeEdge",
            "kind": "LinkedField",
            "name": "invoice",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InvoiceType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetainerPeriodTypeConnection",
                        "kind": "LinkedField",
                        "name": "retainerPeriods",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RetainerPeriodTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RetainerPeriodType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "entries",
                    "args": null,
                    "concreteType": "InvoiceEntryTypeConnection",
                    "kind": "LinkedField",
                    "name": "__Invoice_entries_connection",
                    "plural": false,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "payments",
                    "args": null,
                    "concreteType": "InvoicePaymentTypeConnection",
                    "kind": "LinkedField",
                    "name": "__Invoice_payments_connection",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InvoicePaymentTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InvoicePaymentType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v15/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Person",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v21/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v22/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createInvoiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateInvoicePayload",
        "kind": "LinkedField",
        "name": "createInvoice",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceTypeEdge",
            "kind": "LinkedField",
            "name": "invoice",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InvoiceType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetainerPeriodTypeConnection",
                        "kind": "LinkedField",
                        "name": "retainerPeriods",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RetainerPeriodTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RetainerPeriodType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v31/*: any*/),
                    "concreteType": "InvoiceEntryTypeConnection",
                    "kind": "LinkedField",
                    "name": "entries",
                    "plural": false,
                    "selections": (v24/*: any*/),
                    "storageKey": "entries(first:100000000)"
                  },
                  {
                    "alias": null,
                    "args": (v31/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "Invoice_entries",
                    "kind": "LinkedHandle",
                    "name": "entries"
                  },
                  {
                    "alias": null,
                    "args": (v31/*: any*/),
                    "concreteType": "InvoicePaymentTypeConnection",
                    "kind": "LinkedField",
                    "name": "payments",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InvoicePaymentTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InvoicePaymentType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v15/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Person",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v21/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v22/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v23/*: any*/)
                    ],
                    "storageKey": "payments(first:100000000)"
                  },
                  {
                    "alias": null,
                    "args": (v31/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "Invoice_payments",
                    "kind": "LinkedHandle",
                    "name": "payments"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9b9a9aa1f326eb8f9903aeeb764adf34",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "createInvoice",
            "invoice",
            "node",
            "entries"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "createInvoice",
            "invoice",
            "node",
            "payments"
          ]
        }
      ]
    },
    "name": "createInvoiceMutation",
    "operationKind": "mutation",
    "text": "mutation createInvoiceMutation(\n  $input: CreateInvoiceInput!\n) {\n  createInvoice(input: $input) {\n    invoice {\n      node {\n        id\n        invoiceReference\n        companyInvoiceId\n        name\n        currency\n        invoiceType\n        status\n        dueDay\n        dueMonth\n        dueYear\n        createdDay\n        createdMonth\n        createdYear\n        notes\n        quickbooksId\n        xeroId\n        economicId\n        clientContact {\n          id\n          firstName\n          lastName\n        }\n        project {\n          retainerPeriods {\n            edges {\n              node {\n                invoiced\n                id\n              }\n            }\n          }\n          id\n        }\n        entries(first: 100000000) {\n          edges {\n            node {\n              id\n              name\n              quantity\n              unitPrice\n              discount\n              tax\n              description\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        payments(first: 100000000) {\n          edges {\n            node {\n              id\n              notes\n              amount\n              day\n              month\n              year\n              createdAt\n              createdBy {\n                fullName\n                id\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c64e40dec8749cf39bf34cf01414f08d";

export default node;
